/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Amateur_1_HeadingInputs */

const en_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why setup still earns its place`)
};

const es_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué el setup sigue mereciendo su lugar`)
};

const de_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum Setup immer noch seinen Platz verdient`)
};

const zh_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么准备姿势依然重要`)
};

const ar_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لماذا ما زال الإعداد يستحق مكانه`)
};

const fr_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi la mise en place gagne toujours sa place`)
};

const vi_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vì sao setup vẫn xứng đáng vị trí của nó`)
};

const sw_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa nini maandalizi bado yanastahili nafasi yake`)
};

const th_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำไมการจัดท่าก่อนตียังสำคัญ`)
};

const bs_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zašto setup i dalje zaslužuje svoje mjesto`)
};

const ja_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セットアップが今も欠かせない理由`)
};

const ko_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`셋업이 여전히 필요한 이유`)
};

const pt_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que a preparação continua indispensável`)
};

const it_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il setup merita ancora il suo posto`)
};

const sv_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varför uppställningen fortfarande förtjänar sin plats`)
};

const nl_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom de opstelling nog steeds haar plek verdient`)
};

const da_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor opstillingen stadig fortjener sin plads`)
};

const nb_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor oppstillingen fortsatt fortjener plassen sin`)
};

const fi_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miksi lähtöasento ansaitsee yhä paikkansa`)
};

const pl_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego ustawienie wciąż jest potrzebne`)
};

const ru_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почему исходная позиция по-прежнему важна`)
};

const tr_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazırlık neden yerini hâlâ hak ediyor`)
};

const hi_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटअप आज भी क्यों ज़रूरी है`)
};

const id_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa setup tetap layak mendapat tempatnya`)
};

const ms_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa persediaan masih layak mendapat tempatnya`)
};

const cs_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proč má postavení stále své místo`)
};

const el_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γιατί η προετοιμασία κρατά ακόμη τη θέση της`)
};

const he_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למה עמידת הפתיחה עדיין חשובה`)
};

const af_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom opstelling steeds sy plek verdien`)
};

const hu_method_content_step_01_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miért érdemli ki még mindig a helyét az alapállás`)
};

/**
* | output |
* | --- |
* | "Why setup still earns its place" |
*
* @param {Method_Content_Step_01_Detail_Amateur_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_amateur_1_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Amateur_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Amateur_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_amateur_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_amateur_1_heading(inputs)
	return en_method_content_step_01_detail_amateur_1_heading(inputs)
});